export default __webpack_public_path__ + "db33b877be8f2cbd8ce0ef7d5f763fb3.svg";